import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkProposalsService {
  constructor(private http: HttpClient) {}

  getWorkProposalsData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/work-proposals`);
  }

  updateWorkProposalsData(
    formsId: number,
    workProposalsId: number,
    data: any
  ): Observable<any> {
    return this.http.patch(
      `${environment.api_guia}forms/${formsId}/work-proposals/${workProposalsId}`,
      data
    );
  }
}
